import { notifications } from '@mantine/notifications';

/**
 * Save Free Shipping Bar settings via AJAX
 *
 * @param {Object} settings - Settings object to save
 * @returns {Promise<boolean>} - True if save was successful, false otherwise
 */
export async function saveFreeShippingBarSettings(settings) {
  try {
    const nonce = window.revotyModules?.nonce || window.revotyAdmin?.nonce || '';

    const response = await fetch(window.revotyAdmin.ajaxUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: new URLSearchParams({
        action: 'revoty_save_free_shipping_bar_settings',
        nonce: nonce,
        settings: JSON.stringify(settings),
      }),
    });

    const data = await response.json();

    if (data.success) {
      notifications.show({
        title: 'Success',
        message: data.data.message || 'Settings saved successfully',
        color: 'green',
      });
      return true;
    } else {
      notifications.show({
        title: 'Error',
        message: data.data?.message || 'Failed to save settings',
        color: 'red',
      });
      return false;
    }
  } catch (error) {
    notifications.show({
      title: 'Error',
      message: 'An error occurred while saving settings',
      color: 'red',
    });
    return false;
  }
}
